<template lang="html">
  <div :class="[{ 'status-is-open': isOpenStatus }]">
    <div class="overlay" />
    <v-app-bar app flat color="white" class="app-bar-no-padding">
      <v-container>
        <div class="d-flex align-center">
          <v-btn icon small class="mr-2" @click="goBack">
            <v-icon> mdi-arrow-left </v-icon>
          </v-btn>
          <div class="font-18 font-weight-bold">
            {{ order.order_no }}
          </div>
        </div>
      </v-container>
    </v-app-bar>
    <div v-if="order.status_inquiry === 2" class="banner-store mb-2">
      <v-img
        :src="require('@/assets/img/png/store.png')"
        height="120"
        contain
        style="padding-top: 82px"
      />
    </div>
    <v-container>
      <v-row>
        <v-col cols="12" style="margin-bottom: 72px">
          <!-- <v-card v-if="order.status_inquiry === 2" class="card-border pa-4 mb-2" style="background-color: #FFF2E3;">
            <div class="d-flex align-center">
              <div class="list-content">
                <div class="list-title font-18 font-weight-bold">
                  {{ order.status_desc }}...
                </div>
              </div>
            </div>
          </v-card> -->
          <v-card v-if="order.status === 'P'" class="card-border mb-4 px-2 py-4">
            <div class="d-flex align-center">
              <v-icon color="warning" class="mr-2"> mdi-information </v-icon>
              <div class="list-content">
                <div class="list-title font-18 font-weight-bold">
                  {{ order.status_desc }}
                </div>
              </div>
              <!-- <v-btn v-if="order.payment_mode_name === 'Xendit Virtual Bank' && order.is_paid === 0" :to="{ name: 'va_payment' }" color="warning" height="40" class="soft-shadow text-none font-weight-bold border-10 letter-space-0">
                {{ $t('order.payment') }}
              </v-btn> -->
            </div>
          </v-card>
          <template v-if="order.payment_mode_id === 10 && !order.is_paid">
            <div class="mb-4">
              <div class="order-payment-method">
                <div class="order-payment-method-content">
                  <div class="order-payment-method-subtitle">
                    {{ $t('product.payment_method') }}
                  </div>
                  <div v-if="!order.payment_log" class="order-payment-method-title">
                    {{ order.payment_mode_name }}
                  </div>
                </div>
              </div>
            </div>
            <v-btn
              v-if="order.status === 'P' && !order.is_paid && order.payment_mode_id !== 10"
              color="primary"
              text
              block
              height="40"
              class="text-none font-weight-700 mb-4 letter-space-0"
              @click="changePayment()"
            >
              {{ $t('v2.use_other_payment_method') }}
            </v-btn>
          </template>
          <template v-if="!$isEmpty(order.payment_log) && !order.is_paid">
            <div
              v-if="order.payment_log.payment_source === 'OLSERA-QRIS' && order.status !== 'X'"
              class="__container-qris pa-4 mb-4"
            >
              <div class="mb-6" style="padding: 10px 0">
                <div
                  :class="[
                    '_image-qris-container',
                    { 'qris-expired': formattedTimeLeft === $t('v2.expired') }
                  ]"
                >
                  <div class="_triangle-top">
                    <img :src="require('@/assets/img/png/triangle_top.png')" alt="" />
                  </div>
                  <div class="_image-qris-text">
                    {{ $t('v2.scan_this_qris') }}
                  </div>
                  <div class="col-square _image-qris">
                    <div class="content-square pa-6">
                      <img :src="order.payment_log.qr_image" alt="Qris" class="image-responsive" />
                    </div>
                  </div>
                  <div class="_triangle-bottom">
                    <img :src="require('@/assets/img/png/triangle_bottom.png')" alt="" />
                  </div>
                </div>
              </div>
              <v-btn
                :disabled="formattedTimeLeft === $t('v2.expired')"
                :href="order.payment_log.qr_image"
                download="QRIS.png"
                outlined
                block
                color="#0078CE"
                height="40"
                class="ol-elevation-1 text-none font-weight-700 border-radius-5 mb-4 letter-space-0 btn-download-qris"
              >
                <v-icon left> mdi-download </v-icon>
                {{ $t('v2.download_qris') }}
              </v-btn>
              <div class="pa-4 container-countdown text-center mb-4 white">
                <div
                  :class="[
                    'text-container-countdown',
                    { 'text-expired': formattedTimeLeft === $t('v2.expired') }
                  ]"
                >
                  {{ formattedTimeLeft }}
                </div>
                <div class="subtext-container-countdown">
                  {{
                    formattedTimeLeft === $t('v2.expired')
                      ? $t('v2.your_payment_time_has_expired')
                      : $t('v2.complete_payment_immediately')
                  }}
                </div>
              </div>
              <v-btn
                v-if="
                  formattedTimeLeft !== $t('v2.expired') &&
                  order.status === 'P' &&
                  !order.is_paid &&
                  order.payment_mode_id !== 10
                "
                color="primary"
                text
                block
                height="40"
                class="text-none font-weight-700 mb-4 letter-space-0"
                @click="changePayment()"
              >
                {{ $t('v2.use_other_payment_method') }}
              </v-btn>
              <div>
                <div class="text-center font-16 font-weight-600 mb-4">
                  {{ $t('v2.how_to_pay_with_qris') }}
                </div>
                <ol class="list-qris-guide mb-0">
                  <li>
                    {{ $t('v2.press_the_download_qris_button') }}
                  </li>
                  <li>
                    {{ $t('v2.oppen_an_eWallet_ebanking') }}
                  </li>
                  <li>
                    {{ $t('v2.look_for_the_qris_scan_option') }}
                  </li>
                  <li>
                    {{ $t('v2.after_scanning_the_total_transaction_price_will_appear') }}
                  </li>
                  <li>
                    {{ $t('v2.confirm_and_pay') }}
                  </li>
                  <li>
                    {{ $t('v2.you_have_successfully_paid') }}
                  </li>
                </ol>
              </div>
            </div>
            <div
              v-else-if="
                order.payment_log.payment_source === 'VIRTUAL-ACCOUNT' &&
                order.status !== 'Z' &&
                order.status !== 'X'
              "
              class="container-va pa-4 mb-4"
            >
              <div class="mb-2 d-flex align-center">
                <div class="font-14">
                  {{ $t('dialog.pay_to') }}
                </div>
                <v-spacer />
                <div v-if="!$isEmpty(order.payment_log)">
                  <v-img :src="order.payment_log.payment_image" contain width="50" height="28" />
                </div>
              </div>
              <div class="card--input card-va-number d-flex align-center pa-0 mb-4">
                <div class="font-weight-bold font-18 px-3">
                  {{ order.payment_log.va_account_number }}
                </div>
                <v-spacer />
                <input
                  id="va_account_number"
                  type="hidden"
                  :value="order.payment_log.va_account_number"
                />
                <v-btn
                  class="pa-0"
                  text
                  color="primary"
                  min-width="40"
                  width="40"
                  height="40"
                  @click="copyText('#va_account_number')"
                >
                  <v-icon size="24"> mdi-content-copy </v-icon>
                </v-btn>
              </div>
              <div class="container-time white mb-4">
                <div class="va-icon-time">
                  <v-icon color="#FF931E"> mdi-clock </v-icon>
                </div>
                <div class="va-content-time">
                  <div class="va-content-title">
                    {{ formatDate }}
                  </div>
                  <div class="va-content-subtitle">
                    {{ $t('dialog.finish_payment_before') }}
                  </div>
                </div>
                <div class="va-action">
                  <div class="va-action-time">
                    {{ formatTime }}
                  </div>
                </div>
              </div>
              <v-btn
                v-if="
                  formattedTimeLeft !== $t('v2.expired') &&
                  order.status === 'P' &&
                  !order.is_paid &&
                  order.payment_mode_id !== 10
                "
                color="primary"
                text
                block
                height="40"
                class="text-none font-weight-700 mb-4 letter-space-0"
                @click="changePayment()"
              >
                {{ $t('v2.use_other_payment_method') }}
              </v-btn>
              <v-expansion-panels
                v-if="order.payment_log && order.payment_log.va_bank_code"
                v-model="panel_va"
                class="panel-guide-order"
              >
                <template v-if="order.payment_log.va_bank_code === 'MANDIRI'">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('atm_mandiri.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Mobile Banking
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('mobile_mandiri.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Internet Banking
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('internet_mandiri.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </template>
                <template v-if="order.payment_log.va_bank_code === 'BNI'">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('atm_bni.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Mobile Banking BNI
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('mobile_banking_bni.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Internet Banking BNI
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('internet_banking_bni.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </template>
                <template v-if="order.payment_log.va_bank_code === 'BRI'">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('atm_bri.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Mobile Banking
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('mobile_bri.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Internet Banking
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('internet_bri.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </template>
                <template v-if="order.payment_log.va_bank_code === 'PERMATA'">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      ATM PRIMA / ALTO:
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('atm_permata.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Permata Mobile X
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('permata_mobile_x.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Permata Mobile
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('permata_mobile.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Internet Banking Permata (PermataNet)
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('permata_ib.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </template>
                <template v-if="order.payment_log.va_bank_code === 'BCA'">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      BCA M-Mobile
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('bca_mobile.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('atm_bca.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      IBanking
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('internet_banking_bca.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </template>
                <template v-if="order.payment_log.va_bank_code === 'SAHABAT_SAMPOERNA'">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1"> ATM </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('atm_sahabat_sampoerna.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Mobile Banking
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('mobile_sahabat_sampoerna.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="subtitle-1">
                      Internet Banking
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ol>
                        <li
                          v-for="(step, index) in $t('internet_sahabat_sampoerna.steps', {
                            va_account: order.payment_log.va_account_number
                          })"
                          :key="index"
                          v-html="step"
                        />
                      </ol>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </template>
              </v-expansion-panels>
            </div>
            <div v-else-if="order.payment_log.checkout_url" class="__container-qris pa-4 mb-4">
              <div class="d-flex mb-4">
                <div class="image-order-payment-method image-order-payment-method-ewallet">
                  <img
                    :src="order.payment_log.payment_image"
                    :alt="order.payment_log.payment_type"
                    class="image-ewallet-unpaid"
                  />
                </div>
                <v-spacer />
                <v-btn
                  v-if="formattedTimeLeft !== $t('v2.expired')"
                  :href="order.payment_log.checkout_url"
                  color="#FF931E"
                  class="white--text ml-2 font-16 font-weight-700 text-none letter-space-0"
                >
                  {{ $t('product.pay_now') }}
                </v-btn>
              </div>
              <div class="pa-4 container-countdown text-center mb-4 white">
                <div
                  :class="[
                    'text-container-countdown',
                    { 'text-expired': formattedTimeLeft === $t('v2.expired') }
                  ]"
                >
                  {{ formattedTimeLeft }}
                </div>
                <div class="subtext-container-countdown">
                  {{
                    formattedTimeLeft === $t('v2.expired')
                      ? $t('v2.your_payment_time_has_expired')
                      : $t('v2.complete_payment_immediately')
                  }}
                </div>
              </div>
              <!-- di hide karena dari xendit tidak menyediakan revoke account payemnt sebelumnya untuk type e-wallet -->
              <!-- <v-btn v-if="formattedTimeLeft !== $t('v2.expired') && order.status === 'P' && !order.is_paid && order.payment_mode_id !== 10" color="primary" text block height="40" class="text-none font-weight-700 letter-space-0" @click="changePayment()">
                {{ $t('v2.use_other_payment_method') }}
              </v-btn> -->
            </div>
            <!-- <div v-else-if="order.payment_log.checkout_url" class="mb-4">
              <div class="order-payment-method mb-4">
                <div class="mr-2">
                  <div class="image-order-payment-method">
                    <img :src="order.payment_log.payment_image" :alt="order.payment_log.payment_type" class="image-ewallet-unpaid">
                  </div>
                </div>
                <div class="order-payment-method-content">
                  <div class="order-payment-method-subtitle">
                    {{ $t('product.payment_method') }}
                  </div>
                  <div v-if="!order.payment_log" class="order-payment-method-title">
                    {{ order.payment_mode_name }}
                  </div>
                  <div v-else class="order-payment-method-title">
                    {{ order.payment_log.payment_type }}
                  </div>
                </div>
                <v-spacer />
                <v-btn :href="order.payment_log.checkout_url" color="#FF931E" class="white--text ml-2 font-16 font-weight-700 text-none letter-space-0">
                  {{ $t('product.pay_now') }}
                </v-btn>
              </div>
            </div> -->
          </template>
          <!-- <template v-if="!order.is_paid">
            <div class="order-payment-method mb-4">
              <div v-if="order.payment_log && !$isEmpty(order.payment_log)" class="mr-2">
                <div v-if="order.payment_log.payment_type !== 'QRIS'" class="image-order-payment-method">
                  <v-img :src="order.payment_log.payment_image" contain width="50" height="28" :alt="order.payment_log.payment_type" />
                </div>
                <div v-else-if="order.payment_log.payment_type === 'QRIS' && formattedTimeLeft !== $t('v2.expired')" class="image-order-payment-method">
                  <img :src="order.payment_log.qr_image" @click="dialog.qris_image = true">
                </div>
              </div>
              <div class="order-payment-method-content">
                <div class="order-payment-method-subtitle">
                  {{ $t('product.payment_method') }}
                </div>
                <div v-if="!order.payment_log" class="order-payment-method-title">
                  {{ order.payment_mode_name }}
                </div>
                <div v-else class="order-payment-method-title">
                  {{ order.payment_log.payment_type }}
                </div>
              </div>
              <v-spacer />
              <template v-if="order.payment_log && !$isEmpty(order.payment_log)">
                <input id="#virtual_account_number" type="hidden" :value="order.payment_log.va_account_number">
                <v-btn v-if="order.payment_log.payment_source === 'VIRTUAL-ACCOUNT' && formattedTimeLeft !== $t('v2.expired')" icon color="primary" class="ml-2 mirror" @click="copyText('#virtual_account_number')">
                  <v-icon>
                    mdi-content-copy
                  </v-icon>
                </v-btn>
                <v-btn v-else-if="order.payment_log.payment_type === 'QRIS' && formattedTimeLeft !== $t('v2.expired')" text color="primary" class="ml-2 font-16 font-weight-700 text-none letter-space-0" @click="dialog.qris_image = true">
                  {{ $t('v2.view_qr') }}
                </v-btn>
              </template>
            </div>
            <template v-if="order.payment_log && !$isEmpty(order.payment_log)">
              <div class="pa-4 container-countdown text-center mb-4">
                <div :class="['text-container-countdown', { 'text-expired': formattedTimeLeft === $t('v2.expired') }]">
                  {{ formattedTimeLeft }}
                </div>
                <div class="subtext-container-countdown">
                  {{ formattedTimeLeft === $t('v2.expired') ? $t('v2.your_payment_time_has_expired') : $t('v2.complete_payment_immediately') }}
                </div>
              </div>
              <v-btn v-if="!$isEmpty(order.payment_log) && formattedTimeLeft !== $t('v2.expired')" block color="primary" outlined height="40" class="mb-4 br-5 font-16 font-weight-700 text-none letter-space-0" @click="(dialog.payment_guide = true)">
                {{ $t('v2.payment_guide') }}
              </v-btn>
            </template>
          </template> -->
          <div
            v-if="
              order.status_inquiry !== 1 && order.status_inquiry !== 2 && order.status_inquiry !== 7
            "
            class="mb-4"
          >
            <div class="status-order-stepper">
              <div class="status-order-stepper-item">
                <div
                  :class="[
                    'status-order-stepper-icon',
                    {
                      primary:
                        order.status_inquiry === 3 ||
                        order.status === 'S' ||
                        order.status === 'T' ||
                        order.status === 'R' ||
                        order.status === 'Z'
                    }
                  ]"
                >
                  <v-icon size="18" color="white"> mdi-reload </v-icon>
                </div>
                <div class="status-order-stepper-text">
                  {{ $t('order.processed') }}
                </div>
              </div>
              <hr
                :class="[
                  `line-order-stepper`,
                  {
                    primary:
                      order.status === 'S' ||
                      order.status === 'T' ||
                      order.status === 'R' ||
                      order.status === 'Z'
                  }
                ]"
              />
              <div class="status-order-stepper-item">
                <div
                  :class="[
                    `status-order-stepper-icon`,
                    {
                      primary:
                        order.status === 'S' ||
                        order.status === 'T' ||
                        order.status === 'R' ||
                        order.status === 'Z'
                    }
                  ]"
                >
                  <v-icon v-if="order.remark === 'SELF PICK-UP'" size="18" color="white">
                    mdi-store
                  </v-icon>
                  <v-icon v-else size="18" color="white"> mdi-truck </v-icon>
                </div>
                <div v-if="order.remark === 'SELF PICK-UP'" class="status-order-stepper-text">
                  {{ $t('order.ready_to_pickup') }}
                </div>
                <div v-else class="status-order-stepper-text">
                  {{ $t('order.sent') }}
                </div>
              </div>
              <hr
                :class="[
                  `line-order-stepper`,
                  { primary: order.status === 'T' || order.status === 'R' || order.status === 'Z' }
                ]"
              />
              <div class="status-order-stepper-item">
                <div
                  :class="[
                    `status-order-stepper-icon`,
                    {
                      primary: order.status === 'T' || order.status === 'R' || order.status === 'Z'
                    }
                  ]"
                >
                  <v-icon size="18" color="white"> mdi-package-variant-closed </v-icon>
                </div>
                <div v-if="order.remark === 'SELF PICK-UP'" class="status-order-stepper-text">
                  {{ $t('order.picked_up') }}
                </div>
                <div v-else class="status-order-stepper-text">
                  {{ $t('order.received') }}
                </div>
              </div>
              <hr
                :class="[
                  `line-order-stepper`,
                  { primary: order.status === 'Z' && order.is_paid === 1 }
                ]"
              />
              <div class="status-order-stepper-item">
                <div
                  :class="[
                    `status-order-stepper-icon`,
                    { success: order.status === 'Z' && order.is_paid === 1 }
                  ]"
                >
                  <v-icon size="18" color="white"> mdi-check-bold </v-icon>
                </div>
                <div class="status-order-stepper-text">
                  {{ $t('order.finished') }}
                </div>
              </div>
            </div>
          </div>

          <template v-if="order.remark === 'DELIVERY' && order.shipping_delivery_type === '2'">
            <div
              v-if="
                order.shipping_log.shipper.status === 'inactive' &&
                order.status_mark === 'processed'
              "
              class="d-flex bg-alert-warning-soft px-4 py-4 rounded-lg mb-4"
            >
              <div class="mr-4 d-flex align-center">
                <img src="@/assets/img/png/icon_warning.png" alt="Warning" class="image-24" />
              </div>
              <div class="font-14 line-height-normal">
                {{
                  $t('order.information_shipper_pending_process', {
                    shipper: order.shipping_courier_name
                  })
                }}
              </div>
            </div>
          </template>

          <div v-if="order.status_inquiry === 7" class="order-cancelled">
            <v-icon color="white"> mdi-close-circle </v-icon>
            <div class="order-cancel">
              {{ $t('order.status.cancelled') }}
            </div>
          </div>
          <!-- Gratis Antar -->
          <template v-if="order.remark === 'DELIVERY' && order.shipping_delivery_type === '1'">
            <div
              v-if="order.status_mark === 'processed' || order.status_mark === 'shipping'"
              class="mb-4"
            >
              <OutletCallCardVue
                :order-status="order.status_desc"
                @handle-call="goToWhatsAppOrCall"
              />
            </div>
          </template>
          <!-- Ambil Sendiri -->
          <template v-if="order.remark === 'SELF PICK-UP'">
            <div
              v-if="order.status_mark === 'processed' || order.status_mark === 'ready_to_pickup'"
              class="mb-4"
            >
              <OutletCallCardVue
                :order-status="order.status_desc"
                @handle-call="goToWhatsAppOrCall"
              />
            </div>
          </template>
          <!-- Shipper -->
          <template v-if="order.remark === 'DELIVERY' && order.shipping_delivery_type === '2'">
            <div v-if="order.status_mark === 'processed'" class="mb-4">
              <OutletCallCardVue
                :order-status="order.status_desc"
                @handle-call="goToWhatsAppOrCall"
              />
            </div>
            <div
              v-if="order.status_mark === 'shipping' && isInstantOrSameDayShippingService"
              class="mb-4"
            >
              <CourierCard
                :driver-name="shipper.driverName"
                :driver-phone="shipper.driverPhone"
                :vehicle-type="shipper.vehicleType"
                :vehicle-number="shipper.vehicleNumber"
                :status-shipper="shipper.statusShipper"
                :is-driver="shipper.isDriver"
                :hide-info="false"
              />
            </div>
          </template>
          <div class="d-flex align-center pa-1 mb-3">
            <div class="d-flex mr-4">
              <img :src="require('@/assets/img/svg/icon-history.svg')" alt="" />
            </div>
            <div class="list-content">
              <div class="list-title font-14 font-weight-bold">
                <span
                  v-if="
                    !$isEmpty(order.translogs) && order.translogs.length > 0 && order.status !== 'X'
                  "
                >
                  <template v-if="order.is_paid === 1 && order.status === 'P'">
                    {{ $t('order.status.is_paid') }}
                  </template>
                  <template v-else-if="order.is_paid === 1">
                    {{ order.status_desc }}
                  </template>
                  <template v-else-if="order.is_paid === 0">
                    {{ $t('order.status.bought') }}
                  </template>
                </span>
                <span v-if="order.status === 'X'">
                  {{ $t('order.status.cancelled') }}
                </span>
                <span
                  v-if="
                    order.translogs &&
                    order.translogs.length === 0 &&
                    order.status !== 'X' &&
                    order.is_paid === 0
                  "
                >
                  {{ $t('order.status.bought') }}
                </span>
                <span
                  v-if="
                    order.translogs &&
                    order.translogs.length === 0 &&
                    order.status !== 'X' &&
                    order.is_paid === 1
                  "
                >
                  {{ $t('order.status.is_paid') }}
                </span>
              </div>
              <div class="list-subtitle font-12 grey-color-text">
                <span
                  v-if="(order.translogs && order.translogs.length < 1) || order.status === 'P'"
                >
                  {{ order.forder_date }}, {{ order.forder_time }}
                </span>
                <span v-else>
                  {{ order.fmodified_time }}
                </span>
              </div>
            </div>
            <v-btn
              text
              color="primary"
              class="text-none font-weight-bold letter-space-0"
              @click="isOpenStatus = true"
            >
              {{ $t('order.view_detail') }}
            </v-btn>
          </div>
          <v-card v-if="order.remark === 'SELF PICK-UP'" class="card-border mb-2 px-2 py-3">
            <div class="d-flex mb-4">
              <div class="icon-store-pickup mr-2">
                <img :src="selected_store.logo" :alt="order.store_name" />
              </div>
              <div class="list-content">
                <div class="list-title font-18 font-weight-bold black--text">
                  {{ selected_store.name }}
                </div>
              </div>
            </div>
            <div class="card-pickup mb-4">
              <div class="d-flex">
                <div class="icon-pickup mr-2">
                  <img :src="require('@/assets/img/png/pickup.png')" alt="" />
                </div>
                <div class="list-content">
                  <div class="list-title font-18 font-weight-bold black--text">
                    {{ $t('product.take_by_yourself') }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!$isEmpty(selected_store)" class="card-pickup-store mb-2">
              <div class="d-flex align-center">
                <div class="list-content">
                  <div class="list-subtitle font-14 text-two-line">
                    <b>{{ outletDistance }} km</b> {{ $t('order.from_your_location') }} &#x2022;
                    {{ selected_store.address }}
                  </div>
                </div>
                <div class="ml-2">
                  <input id="store_address" type="hidden" :value="selected_store.address" />
                  <v-btn icon @click="copyText('#store_address')">
                    <v-icon> mdi-content-copy </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div
              v-if="!$isEmpty(selected_store)"
              class="card-pickup-store d-flex justify-space-between"
              @click="openOperationalHours"
            >
              <div class="d-flex align-center">
                <div class="list-content">
                  <div class="list-title font-14 font-weight-bold">
                    <span v-if="selected_store.store_is_open" class="isOpen">
                      {{ $t('layout.open') }}
                    </span>
                    <span v-else class="black--text">
                      {{ $t('layout.close') }}
                    </span>
                  </div>
                  <div
                    v-if="selected_store.shop_hours_today.length > 0"
                    class="list-subtitle font-14 text-two-line"
                    v-html="workingStore"
                  />
                </div>
              </div>
              <v-icon size="20"> mdi-chevron-right </v-icon>
            </div>
          </v-card>
          <template v-else>
            <v-card
              v-if="order.shipping_delivery_type === '1' || order.shipping_delivery_type === '2'"
              class="px-0 py-0 card-border mb-4"
            >
              <div class="card-pickup px-4 py-3">
                <div class="icon-pickup mr-2">
                  <img
                    v-if="order.shipping_delivery_type === '1'"
                    :src="require('@/assets/img/png/free_delivery.png')"
                    :alt="order.shipping_courier_name"
                  />
                  <img
                    v-if="order.shipping_delivery_type === '2'"
                    :src="order.shipping_log.shipper.courier.image_url"
                    :alt="order.shipping_courier_name"
                  />
                </div>
                <div class="list-content">
                  <div class="list-title font-18 font-weight-bold black--text">
                    <span v-if="order.shipping_delivery_type === '1'">
                      {{ $t('global.free_shipping') }}
                    </span>
                    <span v-if="order.shipping_delivery_type === '2'">
                      {{ order.shipping_courier_name }} {{ order.shipping_service_type }}
                    </span>
                  </div>
                  <div
                    v-if="order.shipping_delivery_type === '2'"
                    class="list-title font-12 grey-color-text"
                  >
                    {{ shipper.courierRateName }}
                  </div>
                </div>
                <div class="list-content text-right">
                  <div class="list-subtitle font-12 grey-color-text">
                    {{ $t('order.additional_cost') }}
                  </div>
                  <div class="list-title font-18 font-weight-bold black--text">
                    <span v-if="Number(order.shipping_cost) > 0"
                      >+ <span v-mask-money="order.shipping_cost"
                    /></span>
                    <span v-else>{{ $t('product.free') }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="order.shipping_track_no"
                class="px-4 py-3 d-flex align-center justify-space-between grey lighten-4"
              >
                <div class="d-flex flex-column">
                  <span class="font-14 font-weight-bold">{{
                    order?.shipping_log?.shipper?.order?.awb_number || '-'
                  }}</span>
                  <span class="list-subtitle font-12 grey-color-text">No. Resi</span>
                </div>
                <v-btn class="ml-2" text icon color="primary" @click="copyText('#no_resi')">
                  <input
                    id="no_resi"
                    type="hidden"
                    :value="order?.shipping_log?.shipper?.order?.awb_number"
                  />
                  <v-icon small> mdi-content-copy </v-icon>
                </v-btn>
              </div>
            </v-card>
            <v-card
              v-if="
                order.shipping_cost > 0 &&
                order.remark === 'DELIVERY' &&
                order.shipping_delivery_type === '1'
              "
              class="mb-4 free-shipping-exceed"
            >
              {{ $t('order.distance_exceeded') }} ({{
                Number(order.shipping_radius) - Number(order.shipping_radius_outside)
              }}
              km). {{ $t('order.free_shipping_additional_cost') }}
              {{ $store.state.outlet.selected_outlet.delivery.fcost_outside_radius }}/km
            </v-card>
            <v-card class="card-border mb-2 pa-4">
              <div class="card-pickup mb-4">
                <div class="font-18 font-weight-bold black--text mr-4">
                  {{ $t('order.shipping_address') }}
                </div>
                <div class="list-content text-right">
                  <div class="list-title font-18 font-weight-bold black--text">
                    {{ order.customer_name }}
                  </div>
                </div>
              </div>
              <div class="card-pickup mb-2">
                <div class="list-content">
                  <div class="list-title font-12 black--text text-two-line">
                    {{ order.shipping_address }}
                  </div>
                </div>
                <div class="ml-2 font-12 grey-color-text">
                  {{ order.shipping_radius === 0 ? 1 : order.shipping_radius }} km
                </div>
              </div>
              <v-text-field
                outlined
                prepend-inner-icon="mdi-note-text"
                disabled
                readonly
                dense
                hide-details
                :value="order.shipping_note"
              />
            </v-card>
          </template>
          <v-card class="card-border mt-4 pa-4">
            <div v-for="(item, idx) in order.items" :key="idx" class="d-flex card-order">
              <div class="card-order-item-qty">{{ item.qty }}x</div>
              <div class="card-order-item-content">
                <div class="card-order-item-title">
                  {{ item.item_name }}
                </div>
                <div class="card-order-item">
                  <div class="card-order-item-image">
                    <img
                      v-if="item.product_combo_id === 0"
                      :src="item.product_photo_md"
                      :alt="item.item_name"
                    />
                    <img v-else :src="item.product_combo_photo_md" :alt="item.item_name" />
                  </div>
                  <div class="card-order-item-detail">
                    <div class="card-order-item-weight">
                      <template v-if="item.item_variant_name">
                        {{ item.item_variant_name }}
                      </template>

                      <template v-if="item.uoms?.length"> ({{ item.uoms[0].name }}) </template>

                      <template v-if="item.total_weight"> • {{ item.total_weight }} kg </template>
                    </div>
                    <div class="card-order-item-price">
                      <span v-mask-money="item.price" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
          <v-card v-if="order.notes !== ''" class="card-border mt-4 pa-4">
            <v-text-field
              outlined
              prepend-inner-icon="mdi-note-text"
              readonly
              disable
              dense
              hide-details
              v-html="html_order_notes"
            />
          </v-card>
          <v-card v-if="!$isEmpty(order)" class="card-border mt-4 pa-0">
            <div class="list-price-detail">
              <div class="list-price-item-detail">
                <div>{{ $t('product.sub_total') }}</div>
                <v-spacer />
                <div class="font-weight-bold">
                  ({{ stockInOrderSummary }} {{ $t('product.product') }})
                  <span v-mask-money-no-currency="order.order_amount" />
                </div>
              </div>
              <div v-if="Number(order.discount_sales_amount) > 0" class="list-price-item-detail">
                <div>{{ $t('product.discount') }}</div>
                <v-spacer />
                <div class="font-weight-bold">
                  <span v-if="Number(order.discount_sales_amount) > 0" class="font-discount"
                    >-</span
                  >
                  <span
                    v-mask-money-no-currency="order.discount_sales_amount"
                    :class="[{ 'font-discount': Number(order.discount_sales_amount) > 0 }]"
                  />
                </div>
              </div>
              <div v-if="Number(order.discount_amount) > 0" class="list-price-item-detail">
                <div>Voucher</div>
                <v-spacer />
                <div class="font-weight-bold">
                  <span v-if="Number(order.discount_amount) > 0" class="font-discount">-</span>
                  <span
                    v-mask-money-no-currency="order.discount_amount"
                    :class="[{ 'font-discount': Number(order.discount_amount) > 0 }]"
                  />
                </div>
              </div>
              <div class="list-price-item-detail">
                <div>{{ $t('product.conv_cost') }}</div>
                <v-spacer />
                <div class="font-weight-bold">
                  <span v-mask-money-no-currency="Number(order.trans_fee_amount)" />
                </div>
              </div>
              <div class="list-price-item-detail">
                <div>{{ $t('product.service_cost') }}</div>
                <v-spacer />
                <div class="font-weight-bold">
                  <span v-mask-money-no-currency="order.service_charge_amount" />
                </div>
              </div>
              <div v-if="Number(order.tax_amount) > 0" class="list-price-item-detail">
                <div>PPN</div>
                <v-spacer />
                <div class="font-weight-bold">
                  <span v-mask-money-no-currency="order.tax_amount" />
                </div>
              </div>
              <div class="list-price-item-detail">
                <div>
                  {{ $t('product.shipping_cost') }}
                  {{
                    order.shipping_service_type === 'Regular'
                      ? order.shipping_log.shipper.order.use_insurance
                        ? `(+${$t('order.insurance')})`
                        : ''
                      : ''
                  }}
                </div>
                <v-spacer />
                <div class="font-weight-bold">
                  <span
                    v-if="Number(order.shipping_cost) > 0"
                    v-mask-money-no-currency="order.shipping_cost"
                  />
                  <span v-else>
                    {{ $t('product.free') }}
                  </span>
                </div>
              </div>
              <!-- <template v-if="order.shipping_service_type !== 'Instant' || order.shipping_service_type !== 'Same Day'">
                <div v-if="order.shipping_log.shipper.order.use_insurance" class="list-price-item-detail">
                  <div>{{ $t('order.shipping_insurance') }}</div>
                  <v-spacer />
                  <div class="font-weight-bold">
                    <span v-mask-money-no-currency="order.shipping_log.shipper.order.insurance_fee" />
                  </div>
                </div>
              </template> -->
              <div
                v-if="Number(order.rounded_amount) < 0 || Number(order.rounded_amount) > 0"
                class="list-item-order"
              >
                <div class="item-order-title">
                  {{ $t('order.rounding') }}
                </div>
                <v-spacer />
                <div class="item-order-desc">
                  <span v-mask-money-no-currency="order.rounded_amount" />
                </div>
              </div>
              <div class="list-price-item-detail">
                <div>{{ $t('product.total_payment') }}</div>
                <v-spacer />
                <div class="font-weight-bold">
                  <span v-mask-money-no-currency="order.total_amount" />
                </div>
              </div>
            </div>
          </v-card>
          <!-- <div v-if="Number(data_calculation.point_earn_expected) > 0" class="mt-4">
            <div class="container-point-earn-expected" v-html="$t('product.potential_to_get_points', { point: Number(data_calculation.point_earn_expected) })" />
          </div> -->
          <div v-if="order.is_paid" class="order-payment-method mt-4">
            <div v-if="order.payment_log && !$isEmpty(order.payment_log)" class="mr-2">
              <div
                v-if="order.payment_log.payment_type !== 'QRIS'"
                class="image-order-payment-method"
              >
                <v-img
                  :src="order.payment_log.payment_image"
                  contain
                  width="50"
                  height="28"
                  :alt="order.payment_log.payment_type"
                />
              </div>
              <div
                v-else-if="
                  order.payment_log.payment_type === 'QRIS' &&
                  formattedTimeLeft !== $t('v2.expired')
                "
                class="image-order-payment-method"
              >
                <img src="@/assets/img/png/payment_qris.png" />
              </div>
            </div>
            <div class="order-payment-method-content">
              <div class="order-payment-method-title-is-paid">
                {{ $t('product.payment_method') }}
              </div>
              <div v-if="!order.payment_log" class="order-payment-method-subtitle-is-paid">
                {{ order.payment_mode_name }}
              </div>
              <div v-else class="order-payment-method-subtitle-is-paid">
                {{ order.payment_log.payment_type }}
              </div>
              <div class="order-payment-method-desc-is-paid">
                {{ formatdatepay }}
              </div>
            </div>
          </div>
          <v-btn
            v-if="order.status === 'P' && order.is_paid === 0"
            color="#F44336"
            height="40"
            text
            block
            class="text-none mt-6 font-weight-bold"
            @click="dialog.cancel_order = true"
          >
            {{ $t('dialog.cancel_order') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <div ref="detailStatus" :class="[`status-fixed`, { active: isOpenStatus }]">
      <div class="sheet-bar">
        <div class="sheet-bar-content">
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <v-btn icon class="mr-2" @click="isOpenStatus = !isOpenStatus">
                    <v-icon> mdi-arrow-left </v-icon>
                  </v-btn>
                  <div class="font-18 font-weight-bold">
                    {{ $t('order.log_order') }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="px-3">
              <div class="">
                <div v-for="(item, idx) in arrLog" :key="idx" class="logs-item">
                  <div class="logs-item-header">
                    <div class="logs-item-header-icon">
                      <v-icon v-if="idx == 0" color="#6EBE46"> mdi-check-circle </v-icon>
                      <div v-else class="logs-item-header-icon-bg" />
                    </div>
                    <div class="logs-item-header-content">
                      <div class="logs-item-header-title">
                        {{ item.action_by_name }}
                      </div>
                    </div>
                    <div class="logs-item-header-action">
                      <div class="logs-item-header-action-text">
                        {{ item.faction_time }}
                      </div>
                    </div>
                  </div>
                  <div class="logs-item-body">
                    <div class="logs-item-body-icon">
                      <div
                        v-if="idx !== order.translogs.length - 1"
                        class="logs-item-body-icon-line"
                      />
                    </div>
                    <div class="logs-item-body-content">
                      <div class="logs-item-body-content-text">
                        {{ item.action }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-dialog v-model="dialog.qris_image" max-width="350">
      <v-card v-if="!$isEmpty(order.payment_log) && order.payment_log.qr_image">
        <div class="pa-4">
          <div class="d-flex align-center mb-3">
            <v-spacer />
            <v-btn icon @click="dialog.qris_image = false">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div>
            <div class="col-square mb-4">
              <div class="content-square">
                <img :src="order.payment_log.qr_image" alt="" class="image-responsive" />
              </div>
            </div>
            <v-btn
              :href="order.payment_log.qr_image"
              download="QRIS.png"
              block
              color="primary"
              height="40"
              class="text-none"
            >
              <v-icon left> mdi-download </v-icon>
              Download QRIS
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.cancel_order" max-width="344" content-class="dialog-cancel-order">
      <v-card>
        <v-card-text>
          {{ $t('dialog.are_you_sure_want_to_cancel_the_order') }}
        </v-card-text>
        <v-card-actions>
          <div class="grip-2-column">
            <div>
              <v-btn
                text
                block
                class="text-none btn-dialog-cancel btn-dialog-cancel-no"
                @click="dialog.cancel_order = false"
              >
                No
              </v-btn>
            </div>
            <div>
              <v-btn text block class="text-none btn-dialog-cancel" @click="confirmCancel()">
                {{ $t('dialog.yes_cancel') }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.show">
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div>
          {{ snackbar.text }}
        </div>
        <v-btn class="transparent" text fab x-small dark @click="snackbar.show = false">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <div
      v-if="
        order.status === 'X' ||
        order.status === 'P' ||
        order.status === 'A' ||
        order.status === 'S' ||
        order.status === 'Z' ||
        order.status === 'T' ||
        order.status === 'R'
      "
      :class="[
        'menu-bottom',
        { 'menu-bottom__live-tracking': isInstantOrSameDayShippingService && isLiveTrackingOn }
      ]"
    >
      <div class="wrap-menu-bottom">
        <v-container :class="['d-flex', { 'pa-0': $vuetify.breakpoint.width > 600 }]">
          <v-row :class="[{ 'ma-0 fill-height': $vuetify.breakpoint.width > 600 }]">
            <v-col cols="12" class="py-0" :class="[{ 'px-0': $vuetify.breakpoint.smAndDown }]">
              <div class="d-flex fill-height align-center justify-center">
                <!-- Menunggu Konfirmasi Toko -->
                <v-btn
                  v-if="order.status_mark === 'waiting_confirmation_resto'"
                  tile
                  depressed
                  block
                  height="100%"
                  class="text-none btn-order-bottom"
                  @click="goToWhatsAppOrCall()"
                >
                  {{ $t('order.contact_seller') }}
                </v-btn>
                <!-- Gratis Antar -->
                <template
                  v-if="order.remark === 'DELIVERY' && order.shipping_delivery_type === '1'"
                >
                  <v-btn
                    v-if="order.status_mark === 'waiting_for_payment'"
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="handleRelaod()"
                  >
                    {{ $t('order.reload') }}
                  </v-btn>
                  <v-btn
                    v-if="
                      order.status_mark === 'processed' ||
                      order.status_mark === 'shipping' ||
                      order.status_mark === 'shipped'
                    "
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="handleRelaod()"
                  >
                    {{ $t('order.reload') }}
                  </v-btn>
                  <v-btn
                    v-if="order.status_mark === 'completed' || order.status_mark === 'cancelled'"
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="changePayment(1)"
                  >
                    {{ $t('order.repeat') }}
                    <span class="ml-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.89 10.105C19.676 9.6 19.411 9.11 19.101 8.649L17.443 9.768C17.681 10.12 17.884 10.495 18.047 10.883C18.215 11.281 18.344 11.696 18.43 12.113C18.518 12.546 18.563 12.991 18.563 13.437C18.563 13.883 18.518 14.33 18.43 14.761C18.344 15.179 18.216 15.592 18.046 15.992C17.884 16.378 17.681 16.753 17.443 17.104C17.209 17.451 16.938 17.778 16.64 18.077C16.343 18.374 16.016 18.643 15.667 18.879C15.315 19.117 14.941 19.32 14.553 19.483C14.158 19.65 13.744 19.779 13.324 19.866C12.46 20.041 11.538 20.041 10.678 19.866C10.256 19.779 9.84101 19.65 9.44501 19.482C9.05801 19.319 8.68401 19.116 8.33201 18.878C7.98501 18.645 7.65901 18.375 7.36101 18.078C7.06201 17.778 6.79201 17.45 6.55801 17.105C6.32101 16.754 6.11801 16.379 5.95301 15.99C5.78601 15.594 5.65801 15.181 5.57101 14.76C5.48301 14.329 5.43801 13.884 5.43801 13.437C5.43801 12.99 5.48301 12.545 5.57201 12.113C5.65801 11.693 5.78601 11.279 5.95301 10.883C6.11801 10.493 6.32201 10.118 6.55801 9.769C6.79201 9.422 7.06201 9.095 7.36001 8.797C7.65601 8.5 7.98301 8.23 8.33201 7.995C8.68201 7.759 9.05701 7.555 9.44601 7.39C9.84101 7.223 10.256 7.094 10.676 7.008C10.783 6.986 10.892 6.976 11 6.959V10L16 6L11 2V4.938C10.757 4.967 10.514 5 10.275 5.049C9.72501 5.162 9.18301 5.33 8.66701 5.549C8.15801 5.764 7.66801 6.03 7.21201 6.339C6.75801 6.645 6.33201 6.996 5.94501 7.383C5.55701 7.771 5.20601 8.197 4.90001 8.649C4.59101 9.106 4.32601 9.595 4.11001 10.104C3.89101 10.622 3.72301 11.163 3.61101 11.712C3.49501 12.275 3.43701 12.856 3.43701 13.438C3.43701 14.02 3.49601 14.6 3.61101 15.163C3.72401 15.714 3.89201 16.255 4.11001 16.77C4.32501 17.279 4.59101 17.769 4.90001 18.226C5.20501 18.676 5.55601 19.102 5.94501 19.494C6.33401 19.882 6.75901 20.233 7.21001 20.537C7.66901 20.848 8.15901 21.114 8.66601 21.327C9.18201 21.545 9.72301 21.714 10.275 21.827C10.839 21.941 11.419 22 12 22C12.581 22 13.161 21.941 13.727 21.826C14.278 21.712 14.819 21.544 15.331 21.327C15.838 21.114 16.329 20.848 16.788 20.537C17.241 20.231 17.667 19.88 18.056 19.491C18.444 19.102 18.795 18.677 19.101 18.225C19.413 17.763 19.677 17.273 19.889 16.77C20.109 16.25 20.278 15.709 20.389 15.162C20.504 14.599 20.563 14.018 20.563 13.437C20.563 12.857 20.504 12.276 20.389 11.712C20.277 11.166 20.108 10.625 19.89 10.105Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </v-btn>
                </template>
                <!-- Ambil Sendiri -->
                <template v-if="order.remark === 'SELF PICK-UP'">
                  <v-btn
                    v-if="order.status_mark === 'waiting_for_payment'"
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="handleRelaod()"
                  >
                    {{ $t('order.reload') }}
                  </v-btn>
                  <v-btn
                    v-if="order.status_mark === 'processed' || order.status_mark === 'picked_up'"
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="handleRelaod()"
                  >
                    {{ $t('order.reload') }}
                  </v-btn>
                  <v-btn
                    v-if="order.status_mark === 'ready_to_pickup'"
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="goToGoogleMaps()"
                  >
                    {{ $t('order.store_location') }}
                  </v-btn>
                  <v-btn
                    v-if="order.status_mark === 'completed' || order.status_mark === 'cancelled'"
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="changePayment(1)"
                  >
                    {{ $t('order.repeat') }}
                    <span class="ml-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.89 10.105C19.676 9.6 19.411 9.11 19.101 8.649L17.443 9.768C17.681 10.12 17.884 10.495 18.047 10.883C18.215 11.281 18.344 11.696 18.43 12.113C18.518 12.546 18.563 12.991 18.563 13.437C18.563 13.883 18.518 14.33 18.43 14.761C18.344 15.179 18.216 15.592 18.046 15.992C17.884 16.378 17.681 16.753 17.443 17.104C17.209 17.451 16.938 17.778 16.64 18.077C16.343 18.374 16.016 18.643 15.667 18.879C15.315 19.117 14.941 19.32 14.553 19.483C14.158 19.65 13.744 19.779 13.324 19.866C12.46 20.041 11.538 20.041 10.678 19.866C10.256 19.779 9.84101 19.65 9.44501 19.482C9.05801 19.319 8.68401 19.116 8.33201 18.878C7.98501 18.645 7.65901 18.375 7.36101 18.078C7.06201 17.778 6.79201 17.45 6.55801 17.105C6.32101 16.754 6.11801 16.379 5.95301 15.99C5.78601 15.594 5.65801 15.181 5.57101 14.76C5.48301 14.329 5.43801 13.884 5.43801 13.437C5.43801 12.99 5.48301 12.545 5.57201 12.113C5.65801 11.693 5.78601 11.279 5.95301 10.883C6.11801 10.493 6.32201 10.118 6.55801 9.769C6.79201 9.422 7.06201 9.095 7.36001 8.797C7.65601 8.5 7.98301 8.23 8.33201 7.995C8.68201 7.759 9.05701 7.555 9.44601 7.39C9.84101 7.223 10.256 7.094 10.676 7.008C10.783 6.986 10.892 6.976 11 6.959V10L16 6L11 2V4.938C10.757 4.967 10.514 5 10.275 5.049C9.72501 5.162 9.18301 5.33 8.66701 5.549C8.15801 5.764 7.66801 6.03 7.21201 6.339C6.75801 6.645 6.33201 6.996 5.94501 7.383C5.55701 7.771 5.20601 8.197 4.90001 8.649C4.59101 9.106 4.32601 9.595 4.11001 10.104C3.89101 10.622 3.72301 11.163 3.61101 11.712C3.49501 12.275 3.43701 12.856 3.43701 13.438C3.43701 14.02 3.49601 14.6 3.61101 15.163C3.72401 15.714 3.89201 16.255 4.11001 16.77C4.32501 17.279 4.59101 17.769 4.90001 18.226C5.20501 18.676 5.55601 19.102 5.94501 19.494C6.33401 19.882 6.75901 20.233 7.21001 20.537C7.66901 20.848 8.15901 21.114 8.66601 21.327C9.18201 21.545 9.72301 21.714 10.275 21.827C10.839 21.941 11.419 22 12 22C12.581 22 13.161 21.941 13.727 21.826C14.278 21.712 14.819 21.544 15.331 21.327C15.838 21.114 16.329 20.848 16.788 20.537C17.241 20.231 17.667 19.88 18.056 19.491C18.444 19.102 18.795 18.677 19.101 18.225C19.413 17.763 19.677 17.273 19.889 16.77C20.109 16.25 20.278 15.709 20.389 15.162C20.504 14.599 20.563 14.018 20.563 13.437C20.563 12.857 20.504 12.276 20.389 11.712C20.277 11.166 20.108 10.625 19.89 10.105Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </v-btn>
                </template>
                <!-- Shipper -->
                <template
                  v-if="order.remark === 'DELIVERY' && order.shipping_delivery_type === '2'"
                >
                  <v-btn
                    v-if="order.status_mark === 'waiting_for_payment'"
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="handleRelaod()"
                  >
                    {{ $t('order.reload') }}
                  </v-btn>
                  <v-btn
                    v-if="order.status_mark === 'processed'"
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="goToWhatsAppOrCall()"
                  >
                    {{ $t('order.contact_seller') }}
                  </v-btn>
                  <template v-if="isInstantOrSameDayShippingService">
                    <template v-if="isLiveTrackingOn">
                      <v-btn
                        v-if="order.status_mark === 'shipping'"
                        tile
                        depressed
                        block
                        height="100%"
                        :class="[
                          'text-none',
                          'btn-order-bottom',
                          { 'btn-order-bottom__live-tracking': isLiveTrackingOn }
                        ]"
                        @click="handleOpenLiveTracking()"
                      >
                        {{ $t('order.live_tracking') }}
                      </v-btn>
                      <v-btn
                        v-if="
                          order.status_mark === 'shipped' ||
                          order.status_mark === 'not_documented_status'
                        "
                        tile
                        depressed
                        block
                        height="100%"
                        class="text-none btn-order-bottom"
                        @click="handleRelaod()"
                      >
                        {{ $t('order.reload') }}
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn
                        v-if="order.status_mark === 'shipping' || order.status_mark === 'shipped'"
                        tile
                        depressed
                        block
                        height="100%"
                        class="text-none btn-order-bottom"
                        @click="handleRelaod()"
                      >
                        {{ $t('order.reload') }}
                      </v-btn>
                    </template>
                  </template>
                  <template v-else>
                    <v-btn
                      v-if="order.status_mark === 'shipping'"
                      tile
                      depressed
                      block
                      height="100%"
                      class="text-none btn-order-bottom"
                      @click="goToWhatsAppOrCall()"
                    >
                      {{ $t('order.contact_seller') }}
                    </v-btn>
                    <v-btn
                      v-if="order.status_mark === 'shipped'"
                      tile
                      depressed
                      block
                      height="100%"
                      class="text-none btn-order-bottom"
                      @click="handleRelaod()"
                    >
                      {{ $t('order.reload') }}
                    </v-btn>
                  </template>
                  <v-btn
                    v-if="order.status_mark === 'completed' || order.status_mark === 'cancelled'"
                    tile
                    depressed
                    block
                    height="100%"
                    class="text-none btn-order-bottom"
                    @click="changePayment(1)"
                  >
                    {{ $t('order.repeat') }}
                    <span class="ml-2">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.89 10.105C19.676 9.6 19.411 9.11 19.101 8.649L17.443 9.768C17.681 10.12 17.884 10.495 18.047 10.883C18.215 11.281 18.344 11.696 18.43 12.113C18.518 12.546 18.563 12.991 18.563 13.437C18.563 13.883 18.518 14.33 18.43 14.761C18.344 15.179 18.216 15.592 18.046 15.992C17.884 16.378 17.681 16.753 17.443 17.104C17.209 17.451 16.938 17.778 16.64 18.077C16.343 18.374 16.016 18.643 15.667 18.879C15.315 19.117 14.941 19.32 14.553 19.483C14.158 19.65 13.744 19.779 13.324 19.866C12.46 20.041 11.538 20.041 10.678 19.866C10.256 19.779 9.84101 19.65 9.44501 19.482C9.05801 19.319 8.68401 19.116 8.33201 18.878C7.98501 18.645 7.65901 18.375 7.36101 18.078C7.06201 17.778 6.79201 17.45 6.55801 17.105C6.32101 16.754 6.11801 16.379 5.95301 15.99C5.78601 15.594 5.65801 15.181 5.57101 14.76C5.48301 14.329 5.43801 13.884 5.43801 13.437C5.43801 12.99 5.48301 12.545 5.57201 12.113C5.65801 11.693 5.78601 11.279 5.95301 10.883C6.11801 10.493 6.32201 10.118 6.55801 9.769C6.79201 9.422 7.06201 9.095 7.36001 8.797C7.65601 8.5 7.98301 8.23 8.33201 7.995C8.68201 7.759 9.05701 7.555 9.44601 7.39C9.84101 7.223 10.256 7.094 10.676 7.008C10.783 6.986 10.892 6.976 11 6.959V10L16 6L11 2V4.938C10.757 4.967 10.514 5 10.275 5.049C9.72501 5.162 9.18301 5.33 8.66701 5.549C8.15801 5.764 7.66801 6.03 7.21201 6.339C6.75801 6.645 6.33201 6.996 5.94501 7.383C5.55701 7.771 5.20601 8.197 4.90001 8.649C4.59101 9.106 4.32601 9.595 4.11001 10.104C3.89101 10.622 3.72301 11.163 3.61101 11.712C3.49501 12.275 3.43701 12.856 3.43701 13.438C3.43701 14.02 3.49601 14.6 3.61101 15.163C3.72401 15.714 3.89201 16.255 4.11001 16.77C4.32501 17.279 4.59101 17.769 4.90001 18.226C5.20501 18.676 5.55601 19.102 5.94501 19.494C6.33401 19.882 6.75901 20.233 7.21001 20.537C7.66901 20.848 8.15901 21.114 8.66601 21.327C9.18201 21.545 9.72301 21.714 10.275 21.827C10.839 21.941 11.419 22 12 22C12.581 22 13.161 21.941 13.727 21.826C14.278 21.712 14.819 21.544 15.331 21.327C15.838 21.114 16.329 20.848 16.788 20.537C17.241 20.231 17.667 19.88 18.056 19.491C18.444 19.102 18.795 18.677 19.101 18.225C19.413 17.763 19.677 17.273 19.889 16.77C20.109 16.25 20.278 15.709 20.389 15.162C20.504 14.599 20.563 14.018 20.563 13.437C20.563 12.857 20.504 12.276 20.389 11.712C20.277 11.166 20.108 10.625 19.89 10.105Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </v-btn>
                </template>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <dialog-shop-open-hours v-model="dialog.open_hours" />
    <template v-if="isLiveTrackingOn">
      <DialogLiveTracking
        :open="isOpenLiveTracking"
        :on-close="handleCloseLiveTracking"
        :driver-name="shipper.driverName"
        :driver-phone="shipper.driverPhone"
        :vehicle-type="shipper.vehicleType"
        :vehicle-number="shipper.vehicleNumber"
        :status-shipper="shipper.statusShipper"
        :live-tracking-url="shipper.liveTrackingUrl"
        :is-driver="shipper.isDriver"
      />
    </template>

    <ConfirmationAlert
      :title="'Driver belum ditemukan'"
      :description="'Live Tracking saat ini tidak tersedia'"
      :open="isOpenNotHaveLiveTracking"
      :show-close-button="false"
      :show-confirm-button="false"
      :deny-button-text="'Oke'"
      :on-deny="handleCloseNotHaveLiveTracking"
    />
  </div>
</template>
<script>
import { getOutlet } from '@/api/outlet'
import { order, cancelOrder, orderCalculation } from '@/api/order'
import { getVoucherDetail } from '@/api/voucher'
import { shipperList } from '@/api/shipping'
import { prepareCartItem } from '@/utils/order'
import dialogShopOpenHours from '@/components/order/DialogShopOpenHours'
import ConfirmationAlert from '@/components/alert/ConfirmationAlert.vue'

import { distanceMatrix as distanceMatrixMaps } from '@/api/maps'
import CourierCard from '@/components/order/CourierCard.vue'
import OutletCallCardVue from '@/components/order/OutletCallCard.vue'
import DialogLiveTracking from '@/components/order/DialogLiveTracking.vue'
import io from 'socket.io-client'
import { formatingDateToDay } from '@/utils/helpers'
import { getNextWorkTime } from '@/utils/storeOperational'

export default {
  components: {
    dialogShopOpenHours,
    CourierCard,
    OutletCallCardVue,
    DialogLiveTracking,
    ConfirmationAlert
  },
  data() {
    return {
      panel_va: [0, 1],
      isOpenStatus: false,
      order: {},
      selected_store: {},
      dialog: {
        cancel_order: false,
        open_hours: false,
        qris_image: false,
        payment_guide: false
      },
      html_order_notes: '',
      snackbar: {
        show: false,
        text: ''
      },
      outletDistance: 0,
      timerInterval: null,
      shipper: {
        driverName: '',
        driverPhone: '',
        vehicleNumber: '',
        vehicleType: '',
        statusShipper: '',
        courierRateName: '',
        liveTrackingUrl: '',
        isDriver: 0
      },
      isLiveTrackingOn: false,
      isOpenLiveTracking: false,
      socketShipper: null,
      isOpenNotHaveLiveTracking: false,
      expired_time: 0,
      temporary_cart: {},
      temporary_shipping: {}
    }
  },
  computed: {
    formatdatepay() {
      console.log(this.$i18n.locale)
      const date = new Date(this.order.payment_date)
      return date
    },
    formatDate() {
      if (!this.$isEmpty(this.order.payment_log)) {
        return this.frmtDate(new Date(this.order.payment_log.expired_at))
      } else {
        return this.frmtDate(new Date())
      }
    },
    formatTime() {
      let hours = Math.floor((this.expired_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.expired_time % (1000 * 60 * 60)) / (1000 * 60))
      let result
      if (this.expired_time <= 0) {
        result = this.$t('v2.expired')
      } else {
        hours = hours < 10 ? (hours === 0 ? '' : '0' + hours + 'h ') : hours + 'h '
        minutes = minutes < 10 ? '0' + minutes + 'm' : minutes + 'm'
        result = hours + minutes
      }
      return result
    },
    formattedTimeLeft() {
      if (this.expired_time <= 0) {
        return this.$t('v2.expired')
      }

      let days = Math.floor(this.expired_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.expired_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.expired_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.expired_time % (1000 * 60)) / 1000)

      days = days === 0 ? '' : days + ' : '
      hours = hours < 10 ? (hours === 0 ? '' : '0' + hours + ' : ') : hours + ' : '
      minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
      seconds = seconds < 10 ? '0' + seconds : seconds

      return days + hours + minutes + seconds
    },
    workingStore() {
      if (!this.$isEmpty(this.selected_store)) {
        if (this.selected_store.shop_hours_today.length > 0) {
          const workingHour = this.getWorkingHour()
          if (this.selected_store.store_is_open) {
            return `${workingHour.workingStartTime} - ${workingHour.workingEndTime}`
          } else {
            return `${this.$t('layout.open')} ${workingHour.workingDay}${
              workingHour.workingStartTime ? `, ${workingHour.workingStartTime}` : ''
            }`
          }
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    arrLog() {
      const data = []
      if (!this.$isEmpty(this.order)) {
        for (var i = this.order.translogs.length - 1; i >= 0; i--) {
          data.push(this.order.translogs[i])
        }
      }
      return data
    },
    stockInOrderSummary() {
      if (this.order.items.length > 0) {
        const uniqueIds = []
        const unique = this.order.items.filter(element => {
          const isDuplicate = uniqueIds.includes(element.product_id)
          if (!isDuplicate) {
            uniqueIds.push(element.product_id)
            return true
          }
        })
        return unique.length
      } else {
        return 0
      }
    },
    isRegularShippingService() {
      if (this.order) {
        return ['Regular'].includes(this.order.shipping_service_type)
      }
      return false
    },
    isInstantOrSameDayShippingService() {
      if (this.order) {
        return ['Instant', 'Same Day'].includes(this.order.shipping_service_type)
      }
      return false
    }
  },
  mounted() {
    ;(async () => {
      // Get Order
      await this.getOrder()

      // Socket Shipper
      if (
        this.order.remark === 'DELIVERY' &&
        this.order.shipping_delivery_type === '2' &&
        this.order.is_paid === 1 &&
        this.order.status !== 'P'
      ) {
        this.getShipperSocket()
      }
    })()
  },
  beforeDestroy() {
    if (this.socketShipper) {
      this.socketShipper.disconnect()
    }
  },
  methods: {
    frmtDate(date) {
      const tahun = date.getFullYear()
      let bulan = date.getMonth()
      const tanggal = date.getDate()
      switch (bulan) {
        case 0:
          bulan = this.$t('global.date.january')
          break
        case 1:
          bulan = this.$t('global.date.february')
          break
        case 2:
          bulan = this.$t('global.date.march')
          break
        case 3:
          bulan = this.$t('global.date.april')
          break
        case 4:
          bulan = this.$t('global.date.may')
          break
        case 5:
          bulan = this.$t('global.date.june')
          break
        case 6:
          bulan = this.$t('global.date.july')
          break
        case 7:
          bulan = this.$t('global.date.august')
          break
        case 8:
          bulan = this.$t('global.date.september')
          break
        case 9:
          bulan = this.$t('global.date.october')
          break
        case 10:
          bulan = this.$t('global.date.november')
          break
        case 11:
          bulan = this.$t('global.date.december')
          break
      }
      return tanggal + ' ' + bulan + ' ' + tahun
    },
    goBack() {
      this.$router.push({ name: 'orders' }).catch(() => {})
    },
    async getOrder() {
      try {
        const res = await order(this.$route.params.id)
        const data = res.data.data
        this.order = data
        const dataOrderShipping = data.shipping_log.shipper.order
        this.shipper.courierRateName = dataOrderShipping.courier_rate_name || ''
        if (
          data.remark === 'DELIVERY' &&
          data.shipping_delivery_type === '2' &&
          this.order.status !== 'P'
        ) {
          this.shipper = {
            ...this.shipper,
            driverName: dataOrderShipping.driver.name,
            driverPhone: dataOrderShipping.driver.phone,
            vehicleNumber: dataOrderShipping.driver.vehicle_number,
            vehicleType: dataOrderShipping.driver.vehicle_type,
            statusShipper: dataOrderShipping.status_description,
            liveTrackingUrl: dataOrderShipping.live_tracking || '',
            isDriver: dataOrderShipping.is_driver || 0
          }
        }
        await this.getStore(this.order.store_id)
        if (this.order.notes !== '') {
          this.html_order_notes = this.order.notes.replace(/\n/g, '<br/>')
        }
        if (this.order.remark === 'SELF PICK-UP') {
          this.getDistanceFromStore()
        }
        if (!this.$isEmpty(this.order.payment_log)) {
          if (this.order.payment_log.expired_at && this.order.status_inquiry !== 7) {
            const time = this.order.payment_log.expired_at
            this.getExpiryTime(time)
          }
        }
        if (this.order.is_paid) {
          clearInterval(this.timerOrderInterval)
        }
      } catch (e) {
        this.order = {}
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    async getStore(val) {
      try {
        const { data } = await getOutlet(val)
        this.selected_store = data.data
      } catch (e) {
        this.selected_store = {}
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    async confirmCancel() {
      try {
        await cancelOrder(this.order.sales_order_id)
        this.$router.push({ name: 'orders' }).catch(() => {})
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    goToWhatsAppOrCall() {
      let chatWA = null
      if (!this.$isEmpty(this.$store.state.outlet.selected_outlet)) {
        if (!this.$isEmpty(this.$store.state.outlet.selected_outlet.setting)) {
          chatWA = this.$store.state.outlet.selected_outlet.setting.whatsapp
        }
        if (chatWA) {
          this.$goToWhatsApp(chatWA, 'window')
        } else {
          this.$store.dispatch('showAlert', {
            type: 'error',
            show: true,
            message: this.$t('account.whatsapp_not_been_set')
          })
        }
      }
    },
    goToGoogleMaps() {
      window.open(
        'https://maps.google.com/?q=' +
          this.$store.state.outlet.selected_outlet.location_lat +
          ',' +
          this.$store.state.outlet.selected_outlet.location_lon
      )
    },
    copyText(id) {
      const testingCodeToCopy = document.querySelector(id)
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()
      try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'Copied Successfully' : 'Copy Failed'
        this.snackbar.show = true
        this.snackbar.text = msg
      } catch (err) {
        this.snackbar.show = true
        this.snackbar.text = 'Oops, unable to copy'
      }
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    async getDistanceFromStore() {
      if (!('geolocation' in navigator)) {
        console.log('Geolocation is not available.')
      }
      navigator.geolocation.getCurrentPosition(
        pos => {
          this.getDistance(pos.coords.latitude, pos.coords.longitude)
        },
        () => {
          this.$store.state.block_location = true
        }
      )
    },
    async getDistance(latitude, longitude) {
      const currentLocations = []
      currentLocations.push({
        lat: Number(latitude),
        lon: Number(longitude)
      })
      const form = await {
        origin_lat: Number(this.$store.state.outlet.selected_outlet.location_lat),
        origin_lon: Number(this.$store.state.outlet.selected_outlet.location_lon),
        destination: currentLocations
      }
      await this.checkDistance(form)
    },
    async checkDistance(data_form) {
      try {
        const { data } = await distanceMatrixMaps(data_form)
        if (data.rows[0].elements[0].distance.value > 1000) {
          const value = Math.round(data.rows[0].elements[0].distance.value / 1000)
          this.outletDistance = Number(value.toFixed(0))
        } else {
          const value = Math.ceil(data.rows[0].elements[0].distance.value / 1000)
          this.outletDistance = Number(value.toFixed(0))
        }
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: this.$t('dialog.out_of_range')
        })
      }
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time.replace(' ', 'T')).getTime()
      const _this = this
      this.timerOrderInterval = setInterval(function () {
        var now = new Date().getTime()
        _this.expired_time = countDownDate - now
        if (_this.expired_time <= 0) {
          _this.expired_time = 0
          clearInterval(_this.timerOrderInterval)
        }
      }, 1000)
    },
    openOperationalHours() {
      this.dialog.open_hours = true
    },
    handleRelaod() {
      this.getOrder()
    },
    handleOpenLiveTracking() {
      if (this.shipper.isDriver) {
        this.isOpenLiveTracking = true
      } else {
        this.isOpenNotHaveLiveTracking = true
      }
    },
    handleCloseLiveTracking() {
      this.isOpenLiveTracking = false
    },
    handleCloseNotHaveLiveTracking() {
      this.isOpenNotHaveLiveTracking = false
    },
    getShipperSocket() {
      if (this.order.status === 'S' && this.isInstantOrSameDayShippingService) {
        this.isLiveTrackingOn = true
      }
      const socketShipper = io(`${process.env.VUE_APP_SOCKET_BASE}/shipper`, {
        withCredentials: true,
        extraHeaders: {
          Authorization: process.env.VUE_APP_SOCKET_SHIPPER_KEY
        }
      })
      socketShipper.on('connect', () => {
        if (process.env.NODE_ENV === 'development') {
          console.log('connected to the shipper socket')
        }
      })
      socketShipper.on('connect_error', err => {
        if (process.env.NODE_ENV === 'development') {
          console.error('shipper socket error: ', err)
        }
      })
      socketShipper.on('shipper-olsera', shipper => {
        if (
          shipper &&
          shipper.data &&
          shipper.data.detail &&
          shipper.data.detail.olsera_sales_order_id.toString() ===
            this.order.sales_order_id.toString()
        ) {
          const dataDetail = shipper.data.detail
          const dataSales = shipper.data.sales
          const dataDriver = dataDetail.driver
          // if (dataSales.self_order_status_mark === 'shipping' || dataSales.self_order_status_mark === 'shipped') {
          if (
            dataSales.self_order_status_mark === 'shipping' &&
            this.isInstantOrSameDayShippingService
          ) {
            this.isLiveTrackingOn = true
          } else {
            this.isLiveTrackingOn = false
          }
          this.shipper = {
            ...this.shipper,
            driverName: dataDriver.name,
            driverPhone: dataDriver.phone,
            vehicleNumber: dataDriver.vehicle_number,
            vehicleType: dataDriver.vehicle_type,
            liveTrackingUrl: dataDetail.live_tracking || '',
            statusShipper: dataDetail.status_description,
            isDriver: dataDetail.is_driver
          }
          this.order.status = dataSales.self_order_status
          this.order.status_inquiry = dataSales.self_order_status_inquiry
          this.order.status_mark = dataSales.self_order_status_mark
          this.order.status_desc = dataSales.self_order_status_desc
        }
        // }
      })
      socketShipper.on('disconnect', () => {
        this.isLiveTrackingOn = false
        if (process.env.NODE_ENV === 'development') {
          console.log('Disconnected from the shipper socket')
        }
      })
      this.socketShipper = socketShipper
    },
    getWorkingHour() {
      const selectedOutlet = this.selected_store
      const _getWorkTime = getNextWorkTime(
        selectedOutlet.store_open_date_tomorrow,
        selectedOutlet.store_closing_date_today
      )
      const workingStartTime = _getWorkTime.times[0].fstart_time
      const workingEndTime = _getWorkTime.times[0].fend_time
      const workingDay = formatingDateToDay(_getWorkTime.date)

      return {
        workingStartTime,
        workingEndTime,
        workingDay
      }
    },
    async checkVoucher(id) {
      try {
        const { data } = await getVoucherDetail(id)
        this.$set(this.temporary_cart, 'discount_voucher_id', id)
        this.$set(this.temporary_cart, 'discount_voucher_detail', data.data)
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    async getShipper() {
      try {
        const { data } = await shipperList(this.temporary_cart)
        const shipperSupport = ['Instant', 'Same Day', 'Regular', 'Express', 'Cargo']
        const getData = data.data.filter(shipper => {
          if (shipperSupport.includes(shipper.name)) {
            if (shipper.item.length > 0) {
              return shipper
            }
          }
        })
        const idx_type = getData.findIndex(e => e.name === this.order.shipping_service_type)
        const idx = getData[idx_type].item.findIndex(
          e => e.courier_id === this.order.shipping_courier_id
        )
        const item = getData[idx_type].item[idx]
        const objShipper = {
          name: item.logistic_name,
          type: item.rate_type,
          shipping_courier_id: item.rate_id,
          shipping_service_type: item.rate_type,
          shipment_method: item.rate_type,
          shipment_working_hour: item.working_hour,
          price: item.final_price,
          logo: item.image_url,
          must_use_insurance: item.must_use_insurance,
          insurance_fee: item.insurance_fee,
          insurance_details: item.insurance_details,
          insurance_included: item.insurance_included
        }
        this.temporary_shipping = objShipper

        this.temporary_cart.shipping_courier_id = item.rate_id
        this.temporary_cart.shipping_service_type = this.order.shipping_service_type
        this.temporary_cart.shipping_insurance = false
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    async changePayment(isCart = 0) {
      this.temporary_cart.item = []
      for (const item of this.order.items) {
        this.temporary_cart.item.push(prepareCartItem(item))
      }
      this.temporary_cart.remark = this.order.remark
      this.temporary_cart.currency_id = this.order.currency_id
      this.temporary_cart.notes = ''
      this.temporary_cart.shipping_address = ''
      this.temporary_cart.shipping_address_is_different = 1
      this.temporary_cart.without_shipping = 1
      if (!isCart) {
        this.temporary_cart.previousOrderId = this.order.id
        this.temporary_cart.shipping_address_id = null
        this.temporary_cart.shipping_address = this.order.shipping_address
        this.temporary_cart.shipping_lat = Number(this.order.shipping_lat)
        this.temporary_cart.shipping_lon = Number(this.order.shipping_lon)
        this.temporary_cart.shipping_subdistrict_id = this.order.shipping_subdistrict_id
        this.temporary_cart.shipping_city_id = this.order.shipping_city_id
        this.temporary_cart.shipping_country_id = this.order.shipping_country_id
        this.temporary_cart.shipping_name = 'Kantor'
        this.temporary_cart.shipping_note = this.order.shipping_note
        this.temporary_cart.notes = ''
        this.temporary_cart.without_shipping = this.order.remark === 'DELIVERY' ? 0 : 1
        this.temporary_cart.total = Number(this.order.total_amount)
        this.temporary_cart.shipping_radius = this.order.shipping_radius

        if (this.order.discount_voucher_id) {
          this.checkVoucher(this.order.discount_voucher_id)
        }

        if (this.order.remark === 'DELIVERY') {
          if (Number(this.order.shipping_delivery_type) === 2) {
            await this.getShipper()
          } else {
            this.temporary_shipping.id = 1
            this.temporary_shipping.type = 'free'
            this.temporary_shipping.name = 'Gratis Antar'
            this.temporary_shipping.remark = 'DELIVERY'
            this.temporary_shipping.logo = 'free_delivery'
            this.temporary_shipping.detail = 'Gratis'
            this.temporary_shipping.price = '0'
            this.temporary_shipping.fprice = 'IDR 0'
          }
        } else {
          this.temporary_shipping.id = 3
          this.temporary_shipping.type = 'SelfTake'
          this.temporary_shipping.name = 'Ambil Sendiri'
          this.temporary_shipping.remark = 'SELF PICK-UP'
          this.temporary_shipping.logo = 'pickup'
          this.temporary_shipping.detail = ''
          this.temporary_shipping.price = '0'
          this.temporary_shipping.fprice = 'IDR 0'
        }
        this.$store.commit('SET_TEMPORARY_SHIPPING', this.temporary_shipping)
      }

      try {
        await orderCalculation(this.temporary_cart, {
          globalLoading: false
        })
        this.$store.dispatch('saveDataCart', this.temporary_cart)
        if (isCart) {
          this.$router.push({ name: 'shopping_cart' })
        } else {
          this.$router.push({ name: 'payment_method' })
        }
      } catch (e) {
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
      this.$store.dispatch('remove_order')
    }
  }
}
</script>
